import { render, staticRenderFns } from "./avaliar-janela-tanque.vue?vue&type=template&id=2bfb5018&"
import script from "./avaliar-janela-tanque.vue?vue&type=script&lang=js&"
export * from "./avaliar-janela-tanque.vue?vue&type=script&lang=js&"
import style0 from "./avaliar-janela-tanque.vue?vue&type=style&index=0&lang=css&"
import style1 from "./avaliar-janela-tanque.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports